<template>
  <ss-modal
    v-show="isModalVisible"
    class="xl"
    title="Title"
    intro="bounceIn"
    outro="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      <template v-if="!isEdit">
        Edycja bonifikaty
      </template>
      <template v-else>
        Nowa bonifikata
      </template>
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
      <d-alert
        v-if="discount.discount_active"
        show
        theme="success"
        class="mt-4">
        Bonifikata zatwierdzona
      </d-alert>
      <d-form
        @submit.prevent="validateForm">
        <d-form-row>
          <d-col
            md="6"
            class="form-group">
            <label>Nazwa</label>
              <d-input
                v-validate="'required'"
                type="text"
                name="discount_name"
                v-model="discount.discount_name"
                :class="{'is-invalid' : errors.has('discount_name') }"/>
              <div class="invalid-feedback">{{ errors.first('discount_name') }}</div>
          </d-col>
          <d-col md="6">
            <fieldset class="form-group">
              <label>Typ</label>
              <d-select
                v-validate="'required'"
                name="discount_id"
                v-model="discount.discount_id"
                :class="{'is-invalid' : errors.has('discount_id') }">
                <option :value="null">--Wybierz typ</option>
                <option
                  v-for="item in discountTypes"
                  :key="'type-option-' + item.id"
                  :value="item.id">
                  {{ item.name }}
                </option>
              </d-select>
              <div class="invalid-feedback">{{ errors.first('discount_id') }}</div>
            </fieldset>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col
            md="6"
            class="form-group">
            <label>Status warunku</label>
            <d-checkbox
              class="mt-2 small yes-no"
              toggle
              v-model="discount.discount_condition_met">
              <template v-if="!discount.discount_condition_met">Niespełniony</template>
              <template v-else>Spełniony</template>
            </d-checkbox>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col
            v-if="isDiscountProvisionEnabled"
            md="6"
            class="form-group">
            <label>Wartość prowizji przy uwzględnieniu bonifikaty</label>
            <d-input-group>
              <ss-price-input
                v-validate="isDiscountProvisionEnabled ? 'required|min_value: 0' : ''"
                type="text"
                name="discount_for_provision"
                v-model="discount.discount_for_provision"
                :disabled="!isDiscountProvisionEnabled"
                :class="{'is-invalid' : errors.has('discount_for_provision') }"
                placeholder=""/>
              <d-input-group-text slot="append">PLN</d-input-group-text>
            </d-input-group>
            <div
              v-if="errors.first('discount_for_provision')"
              class="d-block invalid-feedback">
              {{ errors.first('discount_for_provision') }}
            </div>
          </d-col>
          <d-col
            v-if="isDiscountValueEnabled"
            md="6"
            class="form-group">
            <label>Oprocentowanie pożyczki przy uwzględnieniu bonifikaty</label>
            <d-input-group>
              <ss-price-input
                v-validate="isDiscountValueEnabled ? 'required|min_value: 0' : ''"
                type="text"
                name="discount_value"
                v-model="discount.discount_value"
                :disabled="!isDiscountValueEnabled"
                :class="{'is-invalid' : errors.has('discount_value') }"
                placeholder=""/>
              <d-input-group-text slot="append">%</d-input-group-text>
            </d-input-group>
            <div
              v-if="errors.first('discount_value')"
              class="d-block invalid-feedback">
              {{ errors.first('discount_value') }}
            </div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col
            md="6"
            class="form-group">
            <label v-if="isAllocationDiscount">Data zmiany alokacji (wpłaty od tej daty księgowane najpierw na kapitał)</label>
            <label v-else>Data spełnienia warunku otrzymania bonifikaty</label>
            <ss-date
              v-validate="'required'"
              type="text"
              name="discount_date"
              v-model="discount.discount_date"
              :class="{'is-invalid' : errors.has('discount_date') }"
              placeholder=""/>
              <div class="invalid-feedback">{{ errors.first('discount_date') }}</div>
          </d-col>
        </d-form-row>
      </d-form>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      <d-button
        @click.prevent="validateForm"
        :class="{ isLoading: actionInProgress }"
        theme="success" class="ml-3">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import ClientUtils from '@/utils/client';
import SsModal from '@/components/common/SsModal'
import SsPriceInput from '@/components/common/SsPriceInput';
import SsDate from '@/components/common//SsDate';

export default {
  name: 'DiscountFormModal',
  components: {
    ClientUtils,
    SsModal,
    SsPriceInput,
    SsDate
  },
  props: {
    discountTypes: {
      required: true,
      type: Array
    }
  },
  watch: {
    currentDiscountType (newValue) {

      this.$nextTick(() => {
        this.resetFormValidation();
        if (!this.isDiscountValueEnabled) {
          this.discount.discount_value = 0;
        }
        if (!this.isDiscountProvisionEnabled) {
          this.discount.discount_for_provision = 0;
        }
      })
    }
  },
  computed: {
    isEdit () {
      return this.discount && this.discount.id;
    },
    currentDiscountType () {
      if (!this.discount || !this.discount.discount_id) {
        return null;
      }
      return this.discountTypes.find(item => item.id === this.discount.discount_id);
    },
    isAllocationDiscount () {
      return this.currentDiscountType && this.currentDiscountType.type === 'payment_allocation';
    },
    isDiscountProvisionEnabled () {
      if (!this.currentDiscountType || this.currentDiscountType.type === 'interest' || this.isAllocationDiscount) {
        return false;
      }

      return true;
    },
    isDiscountValueEnabled () {
      if (!this.currentDiscountType || this.currentDiscountType.type === 'provision' || this.isAllocationDiscount) {
        return false;
      }

      return true;
    }
  },
  data () {
    return {
      actionInProgress: false,
      discount: {
        discount_active: false, // for button "Zatwierdź"
        discount_condition_met: false,
        discount_date: null,
        discount_for_provision: 0,
        discount_id: null, // id of discount type
        discount_name: '',
        discount_value: 0
      },
      isModalVisible: false,
      selectedDiscountIndex: null
    }
  },
  methods: {
    showModal (selectedDiscount = null, discountIndex = null) {
      Vue.set(this, 'selectedDiscountIndex', discountIndex)

      if (selectedDiscount) {
        Vue.set(this, 'discount', JSON.parse(JSON.stringify(selectedDiscount)));
      } else {
        Vue.set(this, 'discount', _.clone(ClientUtils._discount));
      }

      this.resetFormValidation();

      this.$nextTick(() => {
        this.isModalVisible = true;
      })
    },
    closeModal (shouldReload = false) {
      this.$validator.reset()
      .then(() => {
        this.isModalVisible = false;
        if (shouldReload) {
          this.$emit('save-discount', this.discount, this.selectedDiscountIndex);
        }
      })
    },
    validateForm () {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }

        this.closeModal(true);
      });
    },
    resetFormValidation () {
      this.$validator.pause();
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    }
  }
}
</script>
